import { Component, ElementRef, Input, SimpleChanges, ViewChild, ChangeDetectorRef } from '@angular/core';
import { Chart } from 'chart.js';
import { ChartjsService } from '../../projects/shared/services/chartjs.service';
import { IPieChartDataItem } from '../../projects/shared/models/pie-chart-data-item';


export interface IDonutChartItem {
  label: string;
  value: number;
  color: string;
  icon: string;
  percentage?: number;
  weight?: number;
}

@Component({
    selector: 'app-donut-chart',
    templateUrl: './donut-chart.component.html',
    styleUrl: './donut-chart.component.scss',
    standalone: false
})

export class DonutChartComponent {

  @Input() id: string = 'donut-chart';
  @Input() data: IDonutChartItem[] = [];
  @Input() ballotType: string = '';
  @Input() showDecimalPlaces: boolean = false;
  @Input() showPercentage: boolean = true;

  @ViewChild('donutchart') donutchart: ElementRef<HTMLCanvasElement> = {} as ElementRef<HTMLCanvasElement>;

  total: number = 0;

  private chartInstance: Chart | null = null;

  constructor(private chartjsService: ChartjsService, private cdr: ChangeDetectorRef) {

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data'] && !changes['data'].firstChange) {
        this.init();
    }
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      console.log('DOM fully loaded with a delay');
      this.init();
    });
  }

  init() {
    let chartData: IPieChartDataItem[] = this.data.map((d, i) => { return { label: d.label, count: d.value, color: d.color }; });
    this.calculatePercentages();
    const canvasElement = this.donutchart?.nativeElement ?? document.querySelector(`#${this.id}`);

    if (canvasElement) {
      canvasElement.setAttribute('total-eligible-voter', this.total.toString());
      if (this.chartInstance) this.chartInstance.destroy();
      this.chartInstance = this.chartjsService.renderDoughnutChart(canvasElement, chartData, 'Total');
    }
  }


  calculatePercentages() {
    this.total = this.data.reduce((sum, item) => sum + (item.weight??item.value), 0);
    // Calculate percentage and round
    let percentages = this.data.map(item => ({
      ...item,
      percentage: this.total ?
        this.showDecimalPlaces ?
          Number((((item.weight??item.value) / this.total) * 100).toFixed(2)) :
          Math.round((((item.weight??item.value) / this.total) * 100)) :
        0
    }));

    this.data = percentages;
  }

  getItemColor(item: any): string {
    return item?.color;
  }

  generateId(label: string): string {
    return label.replace(/\s/g, '_').toLowerCase();
  }

}
